import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import LottieAnimation from "vue3-lottie";
import mitt from "mitt";
import { createPinia } from "pinia";
import "@mdi/font/css/materialdesignicons.css";
import "vuetify/styles";
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

// Initialize Vuetify with RTL support
const vuetify = createVuetify({
  components,
  directives,
  // Add RTL support here
  theme: {
    defaultTheme: "light", // You can set your default theme if needed
    themes: {
      light: {
        // Light theme settings
      },
      dark: {
        // Dark theme settings
      },
    },
  },
  rtl: true, // Enable RTL support
});

// Create the Vue app
createApp(App)
  .use(vuetify)
  .use(LottieAnimation)
  .provide("Emitter", mitt())
  .use(createPinia())
  .use(router)
  .mount("#app");
